// src/components/WebsiteChanges/TopSellingProductsBanner.js

import React, { useState } from 'react';
import { motion } from 'framer-motion';

const TopSellingProductsBanner = () => {
  const [bannerTitle, setBannerTitle] = useState('');
  const [bannerImage, setBannerImage] = useState(null);

  const handleFileChange = (e) => {
    setBannerImage(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('bannerTitle', bannerTitle);
    formData.append('bannerImage', bannerImage);

    console.log('Top Selling Products Banner Updated:', {
      bannerTitle,
      bannerImage: bannerImage?.name,
    });

    // Reset form after submission
    setBannerTitle('');
    setBannerImage(null);
  };

  return (
    <div className="relative p-10 py-14 bg-gradient-to-br from-purple-300 to-pink-300 rounded-lg shadow-lg max-w-xl mx-auto overflow-hidden z-10 mt-6 mb-6">
      {/* Decorative Background Lines */}
      <div className="absolute inset-0 bg-white opacity-20 transform -skew-y-2" />
      <div className="absolute inset-0 bg-white opacity-20 transform skew-y-2" />
      
      <motion.h2
        className="relative text-2xl font-bold mb-6 text-indigo-800 tracking-wide z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        Update Top Selling Products Banner 🚀
      </motion.h2>

      <motion.form 
        onSubmit={handleSubmit} 
        className="space-y-5 z-20 bg-white bg-opacity-90 p-6 rounded-lg shadow-md"
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div>
          <label className="block mb-1 font-semibold text-gray-800" htmlFor="bannerTitle">
            Banner Title 📝
          </label>
          <input
            type="text"
            id="bannerTitle"
            value={bannerTitle}
            onChange={(e) => setBannerTitle(e.target.value)}
            className="border border-gray-300 rounded-lg p-2 w-full focus:outline-none focus:ring-2 focus:ring-indigo-600 transition duration-300 transform hover:scale-105"
            placeholder="Enter banner title"
            required
          />
        </div>
        <div>
          <label className="block mb-1 font-semibold text-gray-800" htmlFor="bannerImage">
            Banner Image 🖼️
          </label>
          <input
            type="file"
            id="bannerImage"
            onChange={handleFileChange}
            className="border border-gray-300 rounded-lg p-2 w-full focus:outline-none focus:ring-2 focus:ring-indigo-600 transition duration-300 transform hover:scale-105"
            accept="image/*"
            required
          />
        </div>
        <motion.button
          type="submit"
          className="w-full bg-indigo-600 text-white font-semibold px-4 py-2 rounded-lg shadow transition duration-200 hover:bg-indigo-700 hover:shadow-lg"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Update Banner 🚀
        </motion.button>
      </motion.form>
    </div>
  );
};

export default TopSellingProductsBanner;
